import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { position: number }>(
  {
    root: {
      zIndex: 10000,
      background: 'rgba(0,0,0, .5)',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',

      '& [data-reach-dialog-content]': {
        background: '#ffffff',
        margin: 0,
        padding: [32, 24, 16, 24],
        borderRadius: [32, 32, 0, 0],
        width: 'auto',
      },
    },
    modal: {},
    container: {},
    closeIcon: {},
  },
  { name: 'modal' },
);

export default useStyles;
